import { UserFeature } from './../../_models/user';
import { FeaturePermission } from './../../_models/feature-helper/feature-permissions.model';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureHelperService {

  private userFeatures: Array<UserFeature> = new Array<UserFeature>();
  private _userFeaturesSet: Subject<boolean> = new Subject<boolean>()
  /** The latest refresh of the user's features from the server, while one is running or once it has finished. */
  private refreshing: Observable<unknown> | null = null;

  constructor() { }

  /**
   * Records a refresh of the user's features (AuthGuard's MyFeatures call) so that settled() can wait for it.
   * Returns the refresh shared: subscribing to it and to settled() makes one request.
   */
  public trackRefresh<T>(refresh: Observable<T>): Observable<T> {
    const shared = refresh.pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.refreshing = shared;
    return shared;
  }

  /** Emits once the latest tracked refresh has answered, or at once when none is tracked. */
  public settled(): Observable<void> {
    return (this.refreshing ?? of(null)).pipe(take(1), map(() => undefined));
  }

  public setUserFeatures(userFeatures: UserFeature[]): void {
    this.userFeatures = userFeatures;
    this._userFeaturesSet.next(true);
  }
  public getUserFeatures(): UserFeature[] {
    return this.userFeatures;
  }

  public checkFeaturePermissions(featureList: string[]): FeaturePermission[] {
    let featureSet: Array<FeaturePermission> = new Array<FeaturePermission>();

    featureList.forEach((feature: string) => {
      let itemIndex = this.userFeatures.map(m => m.feature).indexOf(feature);
      if (itemIndex != -1) {
        featureSet.push({ "feature": feature, "enabled": this.userFeatures[itemIndex].enabled });
      } else {
        featureSet.push({ "feature": feature, "enabled": false });
      }
    });

    return featureSet;
  }

  public hasFeature(feature: string): boolean {
    let result = this.userFeatures.find(f => {
      return f.feature === feature;
    });
    if (result === undefined) {
      return false;
    }
    return result.enabled;
  }

  public userFeaturesSet(): Observable<boolean> {
    return this._userFeaturesSet;
  }

}
